import React from "react";
import PieChart from "../PieChart";
import type { SelectedScope } from "../../../types/scope";

interface FindingsByAppsecSubCategoryProps {
  selectedScope?: SelectedScope | null;
  filterToExecute?: string | null;
  scopeToExecute?: string | null;
  id: string;
  setIsReadyToExport?: ((isReady: boolean) => void) | null;
}

const FindingsByAppsecSubCategory: React.FC<
  FindingsByAppsecSubCategoryProps
> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  setIsReadyToExport,
}) => {
  const filtersConfig = {
    filtersjson: filterToExecute || null,
    scopesjson: scopeToExecute || null,
    scopesid: selectedScope?.value?.id,
    filters_fields_to_override: [
      JSON.stringify({
        value: ["APPSEC"],
        field: "category",
        condition: "in",
      }),
      JSON.stringify({
        value: [
          "SCA",
          "IAC",
          "SAST",
          "DAST",
          "IAST",
          "Secrets",
          "CI/CD",
          "Security Posture",
          "API Security",
          "Web scan",
          "Container Image Scanning",
          "Container Runtime Scanning",
          "Serverless Scanning",
          "Mobile Application Security Testing",
          "Bug Bounty",
        ],
        field: "sub_category",
        condition: "in",
      }),
    ],
  };

  const skip =
    (!scopeToExecute && !selectedScope?.value?.id) || !filterToExecute;

  const chartName = `findings-by-category-div-${id}`;

  return (
    <PieChart
      categories={null}
      skip={skip}
      groupBy={["finding.sub_category"]}
      filtersConfig={filtersConfig}
      legendTitle={"Subcategory"}
      chartName={chartName}
      actualFilterField={"sub_category"}
      dataSubject={"Findings"}
      additionalFiltersInDrilldown={["in", "category", "APPSEC"]}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default FindingsByAppsecSubCategory;
